import { render, staticRenderFns } from "./IndemnityHistoryModal.vue?vue&type=template&id=658c7f42&scoped=true"
import script from "./IndemnityHistoryModal.vue?vue&type=script&lang=js"
export * from "./IndemnityHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./IndemnityHistoryModal.vue?vue&type=style&index=0&id=658c7f42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658c7f42",
  null
  
)

export default component.exports